import { Grid, Typography } from '@mui/material';
import { SubmitButton } from '@tassat/button';
import { ClientMessagesTypeMap } from '@tassat/common-definitions';
import React from 'react';

import ClientMessageContentDetails from 'SharedComponents/clientMessages/clientMessageContentDetails';

import type { DeclineClientMessageProps } from '.';

export function DeclineClientMessage(props: DeclineClientMessageProps) {
    const {
        classes,
        selectedMessage,
        declineMessage,
        cancelConfirm,
        approvalError
    } = props;

    return (
        <Grid
            container
            direction='column'
            spacing={0}
        >
            <Typography
                className={classes.promptText}
                variant='body1'
            >Please confirm declining the below {ClientMessagesTypeMap[selectedMessage.ClientMsgType]} message.
            </Typography>
            <ClientMessageContentDetails
                selectedMessage={selectedMessage}
            />
            <Grid
                alignItems='center'
                className={classes.buttonContainer}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <SubmitButton
                    onClick={declineMessage}
                    type='decline'
                />
                {approvalError &&
                    <span>{approvalError}</span>}
                <span
                    className={classes.cancelButton}
                    onClick={cancelConfirm}
                >CANCEL
                </span>
            </Grid>
        </Grid>
    );
}